var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOslash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 303,
    height: 192,
    viewBox: "0 0 303 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.5429 0.100603C72.8174 0.0875067 51.7596 7.7159 34.9581 21.6858C18.1565 35.6558 6.65073 55.1027 2.40154 76.7128C-1.84765 98.3229 1.42266 120.759 11.6552 140.197C21.8877 159.636 38.4492 174.874 58.5174 183.315C78.5857 191.756 100.919 192.878 121.711 186.489C142.504 180.101 160.468 166.597 172.544 148.278C184.62 129.96 190.06 107.962 187.937 86.0318C185.813 64.1017 176.258 43.5968 160.899 28.0116C152.19 19.165 141.846 12.1464 130.46 7.35723C119.074 2.56806 106.869 0.102181 94.5429 0.100603V0.100603ZM94.5429 144.577C83.3304 144.582 72.4633 140.643 63.7934 133.431C55.1235 126.219 49.1873 116.182 46.9963 105.028C44.8053 93.8748 46.4951 82.2959 51.7777 72.2646C57.0603 62.2333 65.609 54.3702 75.9668 50.0153C86.3247 45.6604 97.8509 45.0832 108.581 48.3819C119.312 51.6806 128.583 58.6512 134.814 68.1059C141.045 77.5606 143.851 88.9143 142.754 100.232C141.657 111.55 136.725 122.132 128.798 130.175C124.304 134.745 118.964 138.369 113.086 140.84C107.208 143.312 100.906 144.582 94.5429 144.577V144.577Z",
    fill: "#1A202C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M300.701 0.100586L256.863 95.6464H211.516L255.281 0.100586H300.701Z",
    fill: "#1A202C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M302.291 95.6465L258.526 191.192H213.106L256.862 95.6465H302.291Z",
    fill: "#1A202C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOslash);
export default __webpack_public_path__ + "static/media/oslash.c8fbc8acb4fa14c61e4bbfb416c08c37.svg";
export { ForwardRef as ReactComponent };